<template>
  <div style="width: 100%;height: 500px">
    <iframe id="iframe" frameborder="0" height="500" scrolling="auto" src="https://t.map.qq.com/43TjitZS"
      width="100%"></iframe>
  </div>
</template>

<script>
export default {
  name: "gas-map"
}
</script>

<style scoped></style>
